import React from 'react';
import Button from '../../../components/ui/BTN/Button';

import circle from '../../../assets/images/circle.png'
import balance_company_img from '../../../assets/images/balance_company_img.png'
import wallet_usd from '../../../assets/images/wallet_usd.png'
import wallet_eur from '../../../assets/images/wallet_eur.png'
import transaction_comp from '../../../assets/images/transaction_comp.png'


import charm_tick from '../../../assets/images/charm_tick.svg'
import charm_circle_black from '../../../assets/images/charm_circle_black.svg'


import cl from './Company.module.css'
import { NavLink } from 'react-router-dom';



const Company = () => {
    return (
        <div className='company_page'>
            <div className={cl.business_banking_container}>
                <div className={cl.left_side_banking_side}>
                    <h3 className={cl.left_side_banking_title}>
                        Empower Your Business With Seamless Banking
                    </h3>
                    <p className={cl.banking_description}>
                        Scale your business with a digital bank that understands your needs. From multi-user access to integrated invoicing, we help you manage cash flow efficiently.
                    </p>
                    <NavLink to='/sign_up'>
                        <Button />
                    </NavLink>
                </div>
                <div className={cl.right_side_banking_side}>
                    <img src={circle} alt="#image_page" className={cl.circle} />
                    <img src={balance_company_img} alt="#image_page" className={cl.balance_company_img} />
                    <img src={wallet_usd} alt="#image_page" className={cl.wallet_usd}/>
                    <img src={wallet_eur} alt="#image_page" className={cl.wallet_eur} />
                    <img src={transaction_comp} alt="#image_page" className={cl.transaction_comp} />

                </div>
            </div>
            <div className={cl.keys_feauture_container}>
                <h2 className={cl.keys_feautures_title}>
                    Key Features
                </h2>
                <div className={cl.keys_feautures_row}>
                   <div className={cl.key_feautures_row_upper}>
                     <div className={cl.keys_feautures_item}>
                        <div className={cl.keys_img_wrapper}>
                            <img src={charm_tick} alt="#img_key" />
                        </div>
                        <p className={cl.keys_item_text}>
                            Multi-currency business accounts
                        </p>
                    </div>
                    <div className={[cl.keys_feautures_item, cl.keys_feauture_light].join(' ')}>
                        <div className={cl.keys_img_wrapper}>
                            <img src={charm_circle_black} alt="#img_key" />
                        </div>
                        <p className={cl.keys_item_text}>
                            Team roles and permission management
                        </p>
                    </div>
                    <div className={cl.keys_feautures_item}>
                        <div className={cl.keys_img_wrapper}>
                            <img src={charm_tick} alt="#img_key" />
                        </div>
                        <p className={cl.keys_item_text}>
                            Batch payouts & mass payments
                        </p>
                    </div>
                   </div>
                    <div className={cl.feautures_row_down}>
                        <div className={[cl.keys_feautures_item, cl.keys_feauture_light].join(' ')}>
                        <div className={cl.keys_img_wrapper}>
                            <img src={charm_circle_black} alt="#img_key" />
                        </div>
                        <p className={cl.keys_item_text}>
                            Accounting software integrations
                        </p>
                    </div>
                    <div className={cl.keys_feautures_item}>
                        <div className={cl.keys_img_wrapper}>
                            <img src={charm_tick} alt="#img_key" />
                        </div>
                        <p className={cl.keys_item_text}>
                            Digital invoicing and payment tracking
                        </p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Company;